import { jsx as _jsx } from "react/jsx-runtime";
import { TableCellText } from '../../Cells/TableCellText';
import { TableCellTextStyle } from '../../Cells/TableCellTextStyle';
import { ColumnAlignmentStyles } from '../../Table.interface';
export const TableFooterCell = ({ text, alignment, width = 0 }) => {
    const cellClassName = ['table-foot-cell', ColumnAlignmentStyles[alignment]].filter(Boolean).join(' ');
    return (_jsx("td", { className: cellClassName, style: { flex: width }, children: _jsx(TableCellText, { style: TableCellTextStyle.Quantity, text: text, disabled: false }) }));
};
